import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faCheck, faClock, faDivide, faForward } from "@fortawesome/free-solid-svg-icons";

import "./App.css";
import questions from "./questions";

class App extends Component {
    constructor() {
        super();
        this.state = {
            inGame: false,
            options: [],
            isAnswerModalOpen: false,
            isEndGameModalOpen: false,
            isConfirmExitModalOpen: false,
            is5minMode: false,
            gameMode: "Standard",
            isPaused: false,
            gameModeOptions: {
                old: true,
                new: true,
                easy: true,
                hard: true
            },
            resources: {
                Standard: "https://test.biblequizpro.com/php/question_multichoice.php",
                "True-false": "https://test.biblequizpro.com/php/question_truefalse.php",
                "total questions": "https://test.biblequizpro.com/php/question_total_number.php"
            },
            weightedResourceArray: ["Standard", "Standard", "True-false"]
        };

        this.setGameMode = this.setGameMode.bind(this);
        this.onChangeModeOption = this.onChangeModeOption.bind(this);
        this.openEndGameModal = this.openEndGameModal.bind(this);
        this.openConfirmExitModal = this.openConfirmExitModal.bind(this);
        this.closeConfirmExitModal = this.closeConfirmExitModal.bind(this);
        this.getNumberOfQuestions();
    }

    getNumberOfQuestions() {
        let appThis = this;
        fetch(this.state.resources["total questions"], {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data != null) {
                    data.Mixed = parseInt(data.Standard) + parseInt(data["True-false"]);
                    appThis.setState({
                        totalQuestions: data
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    setGameMode(gameMode) {
        if (!this.state.inGame) {
            this.setState(
                {
                    gameMode: gameMode,
                    is5minMode: gameMode === "5 minutes" ? true : false
                },
                this.onChangeModeOption
            );
        }
    }

    startGame() {
        this.setState(
            {
                inGame: true,
                helpers: {
                    extraTime: this.state.gameMode === "5 minutes" ? false : true,
                    divide: true,
                    skip: true
                },
                questionTime: this.state.gameMode === "5 minutes" ? 0 : 60,
                time: 20,
                points: 0,
                timePoints: 0,
                lifes: 3,
                prevQuestions: { Standard: [], "True-false": [] },
                timeBank: 0,
                gameEndReason: null
            },
            this.fetchQuestion
        );
    }

    endGame() {
        this.interval = false;
        this.setState({
            inGame: false,
            helpers: {},
            prevQuestions: { Standard: [], "True-false": [] },
            timePoints: 0,
            options: [],
            question: ""
        });
    }

    tick() {
        if (this.state.time === 0) {
            this.selectOption(null);
        } else if (!this.state.isPaused) {
            this.setState({
                time: this.state.time - 1
            });
        }
    }

    getOfflineQuestion(currentResource, requestBody) {
        let nextQuestion = null;
        currentResource = currentResource.includes("Standard") ? "Standard" : currentResource;

        for (let i = 0; i < questions.questions[currentResource].length; i++) {
            if (!requestBody.prevQuestions.includes(questions.questions[currentResource][i].id)) {
                nextQuestion = questions.questions[currentResource][i];
                break;
            }
        }
        return nextQuestion;
    }

    fetchQuestion() {
        if (this.state.lifes > 0) {
            let appThis = this;
            let currentResource;
            let hasStandard =
                this.state.gameMode === "Mixed"
                    ? this.state.prevQuestions.Standard.length !== this.state.totalQuestions.Standard
                    : this.state.prevQuestions.Standard.length !== this.state.totalQuestions[this.state.gameMode];
            let hasTrueFalse =
                this.state.prevQuestions["True-false"].length !== this.state.totalQuestions["True-false"];

            if (hasStandard || hasTrueFalse) {
                if ((this.state.gameMode.includes("Standard") || this.state.gameMode === "5 minutes") && hasStandard) {
                    currentResource = "Standard";
                } else if (this.state.gameMode === "True-false" && hasTrueFalse) {
                    currentResource = this.state.gameMode;
                } else if (this.state.gameMode === "Mixed") {
                    if (hasStandard && hasTrueFalse) {
                        currentResource = this.state.weightedResourceArray[
                            Math.floor(Math.random() * this.state.weightedResourceArray.length)
                        ];
                    } else if (hasStandard) {
                        currentResource = "Standard";
                    } else if (hasTrueFalse) {
                        currentResource = "True-false";
                    }
                }
            }

            let requestBody = { prevQuestions: this.state.prevQuestions[currentResource] };

            if (this.state.gameMode === "Standard") {
                requestBody.options = this.state.gameModeOptions;
            }

            if (currentResource) {
                //let data = this.getOfflineQuestion(currentResource, requestBody);
                fetch(this.state.resources[currentResource], {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(requestBody)
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data != null) {
                            let options =
                                currentResource === "Standard"
                                    ? this.shuffle([...data.options.split(";"), data.answer])
                                    : ["True", "False"];
                            let answerIndex;

                            options.forEach((element, index) => {
                                if (element === data.answer) answerIndex = index;
                            });

                            let prevQuestions = { ...this.state.prevQuestions };
                            prevQuestions[currentResource].push(parseInt(data.id));

                            if (appThis.state.gameMode !== "5 minutes" || !appThis.interval) {
                                appThis.interval = setInterval(appThis.tick.bind(appThis), 1000);
                            }

                            appThis.setState({
                                question: data.question,
                                options: options,
                                optionStates: [null, null, null, null],
                                areOptionsDisabled: false,
                                correctOption: data.answer,
                                description: data.description,
                                prevQuestions: prevQuestions,
                                time:
                                    appThis.state.gameMode !== "5 minutes"
                                        ? appThis.state.questionTime
                                        : appThis.state.time,
                                answerIndex: answerIndex,
                                isPaused: false
                            });
                        } else {
                            appThis.openEndGameModal("There are no more questions.");
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            } else {
                appThis.openEndGameModal("There are no more questions.");
            }
        } else {
            this.openEndGameModal("You dont have any lifes left.");
        }
    }

    shuffle(array) {
        let counter = array.length;

        // While there are elements in the array
        while (counter > 0) {
            // Pick a random index
            let index = Math.floor(Math.random() * counter);

            // Decrease counter by 1
            counter--;

            // And swap the last element with it
            let temp = array[counter];
            array[counter] = array[index];
            array[index] = temp;
        }

        return array;
    }

    selectOption(option, index) {
        let newState = {
            timeBank: this.state.time + this.state.timeBank,
            points: this.state.points,
            optionStates: [...this.state.optionStates],
            areOptionsDisabled: true
        };

        if (this.state.gameMode !== "5 minutes") clearInterval(this.interval);
        else newState.isPaused = true;

        if (this.state.correctOption === option) {
            newState.points = newState.points + 1;
            newState.optionStates[index] = true;
        } else {
            newState.lifes = this.state.lifes - 1;
            newState.answerModalTitle = option === null ? "Time up" : "Wrong answer";
            newState.answerModalAnswer = 'The correct answer was "' + this.state.correctOption + '".';
            newState.answerModalDescription = this.state.description;
            newState.isAnswerModalOpen = true;
            newState.optionStates[index] = false;
        }

        let timePoints = Math.floor(newState.timeBank / 100);
        if (this.state.timePoints != timePoints) {
            newState.timePoints = timePoints;
            newState.points = newState.points + 1;
        }

        if (newState.isAnswerModalOpen) this.setState(newState);
        else
            this.setState(newState, () => {
                setTimeout(this.fetchQuestion.bind(this), 1000);
            });
    }

    addExtraTime() {
        if (this.state.helpers.extraTime) {
            let helpers = { ...this.state.helpers };
            helpers.extraTime = false;

            this.setState({
                helpers: helpers,
                time: this.state.time + this.state.questionTime
            });
        }
    }

    divideAnswers() {
        if (this.state.helpers.divide) {
            console.log(this.state);
            let helpers = { ...this.state.helpers };
            helpers.divide = false;
            let indexesToKeep = [this.state.answerIndex, this.getRandomOptionIndex()];

            console.log(indexesToKeep);

            let newoptionStates = this.state.optionStates.map((element, index) => {
                if (indexesToKeep.includes(index)) return element;
                else return "off";
            });

            this.setState({
                helpers: helpers,
                optionStates: newoptionStates
            });
        }
    }

    skipQuestion() {
        if (this.state.gameMode !== "5 minutes") clearInterval(this.interval);

        if (this.state.helpers.skip) {
            let helpers = { ...this.state.helpers };
            helpers.skip = false;

            this.setState(
                {
                    helpers: helpers,
                    isPaused: true
                },
                this.fetchQuestion
            );
        }
    }

    getRandomOptionIndex() {
        let optionIndex = this.state.answerIndex;

        while (optionIndex === this.state.answerIndex) {
            optionIndex = Math.floor(Math.random() * 4);
        }

        return optionIndex;
    }

    openAnswerModal() {
        this.setState({ isAnswerModalOpen: true });
    }

    closeAnswerModal() {
        this.setState({ isAnswerModalOpen: false }, this.fetchQuestion);
    }

    openEndGameModal(gameEndReason) {
        clearInterval(this.interval);
        let newState = { isEndGameModalOpen: true, isConfirmExitModalOpen: false };
        if (gameEndReason && typeof gameEndReason !== "object") {
            newState.gameEndReason = gameEndReason;
        }
        console.log(newState);
        this.setState(newState);
    }

    closeEndGameModal() {
        this.setState({ isEndGameModalOpen: false }, this.endGame);
    }

    openConfirmExitModal() {
        this.setState({ isConfirmExitModalOpen: true });
    }

    closeConfirmExitModal() {
        this.setState({ isConfirmExitModalOpen: false });
    }

    display() {
        if (this.state.inGame)
            return (
                <div className="App-game">
                    <div className="App-game-top">
                        <div className="App-game-top-helpers">
                            <HelperButton
                                icon="time"
                                onClick={this.addExtraTime.bind(this)}
                                isActive={this.state.helpers.extraTime}
                            />
                            <HelperButton
                                icon="divide"
                                onClick={this.divideAnswers.bind(this)}
                                isActive={this.state.helpers.divide}
                            />
                            <HelperButton
                                icon="skip"
                                onClick={this.skipQuestion.bind(this)}
                                isActive={this.state.helpers.skip}
                            />
                        </div>
                        <div className="App-game-top-points">Points: {this.state.points}</div>
                        <div className="App-game-top-timer">Time: {this.state.time}</div>
                        <div className="App-game-top-lifes">Lifes: {this.state.lifes}</div>
                        <div className="App-game-top-exit">
                            <div
                                className="App-link App-game-top-exit-button"
                                onClick={() => this.openConfirmExitModal("You ended the game.")}
                            />
                        </div>
                    </div>
                    <div className="App-game-question">
                        <p>{this.state.question}</p>
                    </div>
                    <div className="App-options">
                        {this.state.options.map((option, index) => {
                            return (
                                <Option
                                    key={index}
                                    optionState={this.state.optionStates[index]}
                                    isDisabled={this.state.areOptionsDisabled}
                                    option={option}
                                    index={index}
                                    onClick={this.selectOption.bind(this)}
                                />
                            );
                        })}
                    </div>
                    <div className="App-game-bottom">
                        <div className="App-game-bottom-question">
                            {"Question: " +
                                (this.state.prevQuestions.Standard.length +
                                    this.state.prevQuestions["True-false"].length) +
                                " / " +
                                this.state.totalQuestions[this.state.gameMode]}
                        </div>
                        <div className="App-game-bottom-time">Time score: {this.state.timeBank}</div>
                        <div className="App-game-bottom-points">Time points: {this.state.timePoints}</div>
                    </div>
                </div>
            );
        else
            return (
                <>
                    <div className="App-button-play App-link" onClick={this.startGame.bind(this)}>
                        <FontAwesomeIcon icon={faPlay} size="4x" />
                        <p className="App-header-link">Play Bible Quiz</p>
                        <p className="App-header-link">
                            {this.state.gameMode.includes("Standard") ? "Standard" : this.state.gameMode} mode
                        </p>
                    </div>
                </>
            );
    }

    onChangeModeOption(modeOption) {
        if (this.state.gameMode.includes("Standard") && !this.state.inGame) {
            let gameMode,
                gameModeOptions = { ...this.state.gameModeOptions };

            switch (modeOption) {
                case "new":
                    gameModeOptions.old = false;
                    gameModeOptions.new = true;
                    break;
                case "old":
                    gameModeOptions.old = true;
                    gameModeOptions.new = false;
                    break;
                case "both":
                    gameModeOptions.old = true;
                    gameModeOptions.new = true;
                    break;
                case "easy":
                    gameModeOptions.easy = true;
                    gameModeOptions.hard = false;
                    break;
                case "hard":
                    gameModeOptions.easy = false;
                    gameModeOptions.hard = true;
                    break;
                case "all":
                    gameModeOptions.easy = true;
                    gameModeOptions.hard = true;
                    break;
                default:
                    gameModeOptions.old = true;
                    gameModeOptions.new = true;
                    gameModeOptions.easy = true;
                    gameModeOptions.hard = true;
            }

            //set game mode
            if (gameModeOptions.old && gameModeOptions.new && gameModeOptions.easy && gameModeOptions.hard)
                gameMode = "Standard";
            else if (!gameModeOptions.old && !gameModeOptions.new && !gameModeOptions.easy && !gameModeOptions.hard)
                gameMode = "Standard";
            else if (gameModeOptions.old && gameModeOptions.new && !gameModeOptions.easy && !gameModeOptions.hard)
                gameMode = "Standard";
            else if (!gameModeOptions.old && !gameModeOptions.new && gameModeOptions.easy && gameModeOptions.hard)
                gameMode = "Standard";
            else if (gameModeOptions.old && gameModeOptions.new && !gameModeOptions.easy && gameModeOptions.hard)
                gameMode = "StandardHard";
            else if (!gameModeOptions.old && !gameModeOptions.new && !gameModeOptions.easy && gameModeOptions.hard)
                gameMode = "StandardHard";
            else if (gameModeOptions.old && gameModeOptions.new && gameModeOptions.easy && !gameModeOptions.hard)
                gameMode = "StandardEasy";
            else if (!gameModeOptions.old && !gameModeOptions.new && gameModeOptions.easy && !gameModeOptions.hard)
                gameMode = "StandardEasy";
            else if (!gameModeOptions.old && gameModeOptions.new && gameModeOptions.easy && gameModeOptions.hard)
                gameMode = "StandardNew";
            else if (!gameModeOptions.old && gameModeOptions.new && !gameModeOptions.easy && !gameModeOptions.hard)
                gameMode = "StandardNew";
            else if (gameModeOptions.old && !gameModeOptions.new && gameModeOptions.easy && gameModeOptions.hard)
                gameMode = "StandardOld";
            else if (gameModeOptions.old && !gameModeOptions.new && !gameModeOptions.easy && !gameModeOptions.hard)
                gameMode = "StandardOld";
            else if (gameModeOptions.old && !gameModeOptions.new && gameModeOptions.easy && !gameModeOptions.hard)
                gameMode = "StandardOldEasy";
            else if (gameModeOptions.old && !gameModeOptions.new && !gameModeOptions.easy && gameModeOptions.hard)
                gameMode = "StandardOldHard";
            else if (!gameModeOptions.old && gameModeOptions.new && gameModeOptions.easy && !gameModeOptions.hard)
                gameMode = "StandardNewEasy";
            else if (!gameModeOptions.old && gameModeOptions.new && !gameModeOptions.easy && gameModeOptions.hard)
                gameMode = "StandardNewHard";

            this.setState({ gameModeOptions: gameModeOptions, gameMode: gameMode });
        }
    }

    render() {
        return (
            <>
                <div className="App">
                    <div className="app-window-wrapper">
                        <div className="App-menu-show">
                            <div className="App-menu-note-wrapper">
                                <div className="App-menu-note">
                                    <div className="App-menu-title">Site Navigation</div>
                                    <div className="App-menu-mode">
                                        <a href="/article1.html">Article 1</a>
                                    </div>
                                    <div className="App-menu-mode">
                                        <a href="/article2.html">Article 2</a>
                                    </div>
                                    <div className="App-menu-mode">
                                        <a href="/article3.html">Article 3</a>
                                    </div>
                                    <div className="App-menu-mode">
                                        <a href="/article4.html">Article 4</a>
                                    </div>
                                    <div className="App-menu-mode">
                                        <a href="/article5.html">Article 5</a>
                                    </div>
                                </div>
                            </div>
                            <div className="App-menu-note-wrapper">
                                <div className="App-menu-note">
                                    <div className="App-menu-title">Game modes</div>
                                    <div
                                        className={
                                            "App-menu-mode App-menu-mode-" + (this.state.inGame ? "inactive" : "active")
                                        }
                                        onClick={() => this.setGameMode("Standard")}
                                    >
                                        Standard{" "}
                                        {this.state.gameMode.includes("Standard") && (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        )}
                                    </div>
                                    <div
                                        className={
                                            "App-menu-mode App-menu-mode-" + (this.state.inGame ? "inactive" : "active")
                                        }
                                        onClick={() => this.setGameMode("5 minutes")}
                                    >
                                        5 Minutes{" "}
                                        {this.state.gameMode === "5 minutes" && (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        )}
                                    </div>
                                    <div
                                        className={
                                            "App-menu-mode App-menu-mode-" + (this.state.inGame ? "inactive" : "active")
                                        }
                                        onClick={() => this.setGameMode("True-false")}
                                    >
                                        True-false{" "}
                                        {this.state.gameMode === "True-false" && (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        )}
                                    </div>
                                    <div
                                        className={
                                            "App-menu-mode App-menu-mode-" + (this.state.inGame ? "inactive" : "active")
                                        }
                                        onClick={() => this.setGameMode("Mixed")}
                                    >
                                        Mixed{" "}
                                        {this.state.gameMode === "Mixed" && (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="App-menu-note-wrapper">
                                <div className="App-menu-note">
                                    <div className="App-menu-title">Game options</div>
                                    <div
                                        className={
                                            "App-menu-option App-menu-option-" +
                                            (this.state.gameMode.includes("Standard") && !this.state.inGame
                                                ? "active"
                                                : "inactive")
                                        }
                                        onClick={() => this.onChangeModeOption("old")}
                                    >
                                        Old Testament{" "}
                                        {this.state.gameModeOptions.old && !this.state.gameModeOptions.new ? (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        ) : null}
                                    </div>
                                    <div
                                        className={
                                            "App-menu-option App-menu-option-" +
                                            (this.state.gameMode.includes("Standard") && !this.state.inGame
                                                ? "active"
                                                : "inactive")
                                        }
                                        onClick={() => this.onChangeModeOption("new")}
                                    >
                                        New Testament{" "}
                                        {!this.state.gameModeOptions.old && this.state.gameModeOptions.new ? (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        ) : null}
                                    </div>
                                    <div
                                        className={
                                            "App-menu-option App-menu-option-" +
                                            (this.state.gameMode.includes("Standard") && !this.state.inGame
                                                ? "active"
                                                : "inactive")
                                        }
                                        onClick={() => this.onChangeModeOption("both")}
                                    >
                                        All Testaments{" "}
                                        {this.state.gameModeOptions.old && this.state.gameModeOptions.new ? (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        ) : null}
                                    </div>
                                    <div className="App-menu-option">
                                        <wbr />
                                    </div>
                                    <div
                                        className={
                                            "App-menu-option App-menu-option-" +
                                            (this.state.gameMode.includes("Standard") && !this.state.inGame
                                                ? "active"
                                                : "inactive")
                                        }
                                        onClick={() => this.onChangeModeOption("easy")}
                                    >
                                        Easy questions{" "}
                                        {!this.state.gameModeOptions.hard && this.state.gameModeOptions.easy ? (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        ) : null}
                                    </div>
                                    <div
                                        className={
                                            "App-menu-option App-menu-option-" +
                                            (this.state.gameMode.includes("Standard") && !this.state.inGame
                                                ? "active"
                                                : "inactive")
                                        }
                                        onClick={() => this.onChangeModeOption("hard")}
                                    >
                                        Hard questions{" "}
                                        {this.state.gameModeOptions.hard && !this.state.gameModeOptions.easy ? (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        ) : null}
                                    </div>
                                    <div
                                        className={
                                            "App-menu-option App-menu-option-" +
                                            (this.state.gameMode.includes("Standard") && !this.state.inGame
                                                ? "active"
                                                : "inactive")
                                        }
                                        onClick={() => this.onChangeModeOption("all")}
                                    >
                                        All questions{" "}
                                        {this.state.gameModeOptions.hard && this.state.gameModeOptions.easy ? (
                                            <FontAwesomeIcon icon={faCheck} size="1x" />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="App-window">
                            <div className="App-window-inner">{this.display()}</div>
                        </div>
                    </div>

                    <AnswerModal
                        isActive={this.state.isAnswerModalOpen}
                        title={this.state.answerModalTitle}
                        answer={this.state.answerModalAnswer}
                        description={this.state.answerModalDescription}
                        onClose={this.closeAnswerModal.bind(this)}
                    />

                    <EndGameModal
                        isActive={this.state.isEndGameModalOpen}
                        gameEndReason={this.state.gameEndReason}
                        points={this.state.points}
                        onClose={this.closeEndGameModal.bind(this)}
                    />

                    <ConfirmExitModal
                        isActive={this.state.isConfirmExitModalOpen}
                        onConfirm={this.openEndGameModal}
                        onClose={this.closeConfirmExitModal}
                    />
                </div>
            </>
        );
    }
}

class HelperButton extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div
                className={[
                    "App-game-top-helper-button",
                    "App-game-top-helper-button-" +
                        this.props.icon +
                        "-" +
                        (this.props.isActive ? "active" : "inactive")
                ].join(" ")}
                onClick={this.props.onClick}
            />
        );
    }
}

class Option extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div
                className={"App-option App-option-" + this.props.optionState}
                onClick={
                    this.props.optionState === null && this.props.isDisabled === false
                        ? () => this.props.onClick(this.props.option, this.props.index)
                        : null
                }
            >
                <p>{this.props.option}</p>
            </div>
        );
    }
}

class AnswerModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={"App-modal App-modal-" + (this.props.isActive ? "open" : "closed")}>
                <div className="App-modal-content">
                    <div className="App-modal-top">
                        <div className="App-modal-title">Answer</div>
                        <div
                            className="App-link App-game-top-exit-button App-modal-close"
                            onClick={this.props.onClose}
                        />
                    </div>
                    <div className="App-modal-body-answer">
                        <p>{this.props.answer}</p>
                        <p>{this.props.description}</p>
                    </div>
                </div>
            </div>
        );
    }
}

class EndGameModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={"App-modal App-modal-" + (this.props.isActive ? "open" : "closed")}>
                <div className="App-modal-content">
                    <div className="App-modal-top">
                        <div className="App-modal-title">Game Over</div>
                        <div
                            className="App-link App-game-top-exit-button App-modal-close"
                            onClick={this.props.onClose}
                        />
                    </div>
                    <div className="App-modal-body-end">
                        <p>{this.props.gameEndReason}</p>
                        <p>Congratulations! You achieved {this.props.points} points.</p>
                    </div>
                </div>
            </div>
        );
    }
}

class ConfirmExitModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={"App-modal App-modal-" + (this.props.isActive ? "open" : "closed")}>
                <div className="App-modal-content">
                    <div className="App-modal-top">
                        <div className="App-modal-title">Please confirm</div>
                    </div>
                    <div className="App-modal-body-end">
                        <p>Are you sure you would like to end the game?</p>
                    </div>
                    <div className="App-modal-footer">
                        <div className="App-modal-footer-button-wrapper">
                            <div className="App-modal-footer-button" onClick={this.props.onConfirm}>
                                Yes
                            </div>
                        </div>
                        <div className="App-modal-footer-button-wrapper">
                            <div className="App-modal-footer-button" onClick={this.props.onClose}>
                                No
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
